import React from "react";

import { StyledSVG } from "../StyledIcon";

export const NotificationIcon = props => {
  const { iconColor, iconWidth, iconHeight } = props;

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <path
        d="M7.125 2.0024C7.69507 1.67327 8.34174 1.5 9 1.5C9.65826 1.5 10.3049 1.67327 10.875 2.00241"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.25 13.5C11.25 13.7955 11.1918 14.0881 11.0787 14.361C10.9657 14.634 10.7999 14.8821 10.591 15.091C10.3821 15.2999 10.134 15.4657 9.86104 15.5787C9.58806 15.6918 9.29547 15.75 9 15.75C8.70453 15.75 8.41194 15.6918 8.13896 15.5787C7.86598 15.4657 7.61794 15.2999 7.40901 15.091C7.20008 14.8821 7.03434 14.634 6.92127 14.361C6.8082 14.0881 6.75 13.7955 6.75 13.5"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.4471 5.17785L11.9168 5.70818L11.9168 5.70818L12.4471 5.17785ZM9 3.75V3V3.75ZM5.55285 5.17785L5.02252 4.64752L5.55285 5.17785ZM4.125 8.625L3.375 8.625V8.625H4.125ZM4.125 10.5V11.25C4.53921 11.25 4.875 10.9142 4.875 10.5H4.125ZM3 10.5V9.75C2.58579 9.75 2.25 10.0858 2.25 10.5H3ZM3 13.5H2.25C2.25 13.9142 2.58579 14.25 3 14.25V13.5ZM15 13.5V14.25C15.4142 14.25 15.75 13.9142 15.75 13.5H15ZM15 10.5H15.75C15.75 10.0858 15.4142 9.75 15 9.75V10.5ZM13.875 10.5H13.125C13.125 10.9142 13.4608 11.25 13.875 11.25V10.5ZM11.9168 5.70818C12.6904 6.48177 13.125 7.53098 13.125 8.625H14.625C14.625 7.13316 14.0324 5.70242 12.9775 4.64752L11.9168 5.70818ZM9 4.5C10.094 4.5 11.1432 4.9346 11.9168 5.70818L12.9775 4.64752C11.9226 3.59263 10.4918 3 9 3V4.5ZM6.08318 5.70818C6.85677 4.9346 7.90598 4.5 9 4.5V3C7.50816 3 6.07742 3.59263 5.02252 4.64752L6.08318 5.70818ZM4.875 8.625C4.875 7.53098 5.3096 6.48177 6.08318 5.70818L5.02252 4.64752C3.96763 5.70242 3.375 7.13316 3.375 8.625L4.875 8.625ZM4.875 10.5V8.625H3.375V10.5H4.875ZM3 11.25H4.125V9.75H3V11.25ZM3.75 13.5V10.5H2.25V13.5H3.75ZM4.125 12.75H3V14.25H4.125V12.75ZM13.875 12.75H4.125V14.25H13.875V12.75ZM15 12.75H13.875V14.25H15V12.75ZM14.25 10.5V13.5H15.75V10.5H14.25ZM13.875 11.25H15V9.75H13.875V11.25ZM13.125 8.625V10.5H14.625V8.625H13.125Z"
        fill={iconColor}
      />
    </StyledSVG>
  );
};
